import { render } from "./HoverArticle.vue?vue&type=template&id=285e7a82&scoped=true"
import script from "./HoverArticle.vue?vue&type=script&lang=js"
export * from "./HoverArticle.vue?vue&type=script&lang=js"

import "./HoverArticle.vue?vue&type=style&index=0&id=285e7a82&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-285e7a82"]])

export default __exports__